export const formatDateDMY = (date) => {
    if (!date) return "-"; // Handle missing dates gracefully
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0"); // Add leading zero
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Add leading zero (months are 0-indexed)
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };